import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Modal } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { Picture } from "../Picture";
import { useIsMobileDimension } from "../../hooks/useGetDimensionGroup";
import { VideoPlayer } from "../VideoPlayer";
import style from "./styles.module.pcss";
import IconPlay from "../../assets/svg/play.svg";
var cx = classNames.bind(style);
export var Video = function Video(_ref) {
  var _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? true : _ref$autoplay,
    alt = _ref.alt,
    poster = _ref.poster,
    src = _ref.src,
    rutubeId = _ref.rutubeId,
    youtubeId = _ref.youtubeId,
    onClick = _ref.onClick,
    height = _ref.height;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenVideo = _useState2[0],
    setIsOpenVideo = _useState2[1];
  var isMobile = useIsMobileDimension();
  var handleClick = function handleClick() {
    onClick === null || onClick === void 0 ? void 0 : onClick();
    if (!isOpenVideo && poster) setIsOpenVideo(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    className: cx('container'),
    onClick: handleClick,
    style: height ? {
      height: height
    } : undefined,
    type: "button",
    "data-t-id": "components-Video"
  }, isOpenVideo && isMobile || !poster ? /*#__PURE__*/React.createElement(VideoPlayer, {
    autoplay: poster ? autoplay : false,
    poster: poster,
    rutubeId: rutubeId,
    src: src,
    youtubeId: youtubeId
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconPlay, {
    className: cx('video--paused')
  }), /*#__PURE__*/React.createElement(Picture, {
    alt: alt,
    className: cx('poster'),
    src: poster
  }))), isOpenVideo && !isMobile && /*#__PURE__*/React.createElement(Modal, {
    isFixedMinValues: true,
    isNoPadding: true,
    isOpen: isOpenVideo,
    onClose: function onClose() {
      return setIsOpenVideo(false);
    }
  }, /*#__PURE__*/React.createElement(VideoPlayer, {
    autoplay: poster ? autoplay : false,
    poster: poster,
    rutubeId: rutubeId,
    src: src,
    youtubeId: youtubeId,
    "data-t-id": "components-Video"
  })));
};